<template>
  <div class="authenticate">
    <div class="p-4 float-right">
      <router-link :to="{ name:'LoginByPassword' }" class="ar-btn size-md round primary">ورود</router-link>
    </div>
    <router-link :to="{name:'Home'}" class="p-2 float-left">
      <img class="logo-top" :src="this.StaticImageUrl+'assets/images/logo/logo-dark.png'">
    </router-link>

    <div class="form-out">
      <div class="form-in text-center">

        <div class="icon-lg">
          <div class="icon-wrapper">
            <img :src="this.StaticImageUrl+'assets/images/site-icons/mobile-alt.svg'" alt="">
          </div>
        </div>

        <div class="ar-form-group">
          <label>لطفا شماره تلفن همراه خود را وارد کنید</label>
          <input v-if="foreign_number" class="ar-form-control text-center latin-input-3" autofocus v-model="data.mobile_number" placeholder="- - - - - - - - - - - - - - -" @keypress="just_float($event)"/>
          <the-mask v-else class="ar-form-control text-center latin-input-3" autofocus :masked="true" v-model="data.mobile_number" placeholder="0 9 - - - - - - - - -" :mask="[
            '09#########'
          ]" />
          <div v-if="errors.mobile_number" class="ar-form-text">
            <small>{{errors.mobile_number[0]}}</small>
          </div>
        </div>

        <div class="ar-form-group">
          <div class="pb-2 text-right d-flex align-items-center flex-wrap"><input type="checkbox" v-model="foreign_number" class="mx-2"><div>کاربر با شماره خارج از ایران </div></div>
        </div>

        <br>
        <br>
        
        <div class="ar-form-group">
          <div class="pb-2 text-right d-flex align-items-center flex-wrap"><input type="checkbox" v-model="has_referral" class="mx-2"> <div>معرف دارم </div> <small class="mx-1">(با داشتن کد معرف می توانید درآمد کسب کنید.)</small></div>
          <input class="ar-form-control text-center latin-input-3" v-show="has_referral" v-model="data.ref_code" :disabled="is_ref_code_disable" placeholder="کد یا تلفن همراه معرف" />
          <div class="text-right mx-4 mb-2">
            <router-link :to="{ name:'AboutUs' }" class="ar-link info">
              <b class="mx-1">بیشتر بدانید <i class="fa fa-info-circle"></i></b>
            </router-link>
          </div>
        </div>
      
        <h4 v-if="errorMessage" class="ar-alert danger round mb-3">
          <small>{{errorMessage}}</small>
        </h4>

        <div class="mb-4">
          <button @click="SendCode" class="ar-btn size-md block round primary">ثبت نام</button>
        </div>

        <div class="text-center mb-2">
          قبلا ثبت نام کرده اید؟ <router-link :to="{ name:'LoginByPassword' }" class="ar-link info">وارد شوید</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'
export default {
  name: 'Register',
  components:{
    TheMask
  },
  data : () => ({
    data:{
      ref_code:null,
      mobile_number:'',
      from:'site',
      type:'register'
    },
    errorMessage:null,
    errors:{},
    pp:{
      a:false,
      b:false,
      c:false,
    },
    password : null,
    show_password : false,
    has_referral : false,
    foreign_number : false,
    is_ref_code_disable : false
  }),
  watch:{
    password(){
      const pass = this.password
      if(/\d/.test(pass)){
        this.pp.b = true
      }else{
        this.pp.b = false
      }

      const
      upper = /[A-Z]/.test(pass),
      lower = /[a-z]/.test(pass);
      if(upper && lower){
        this.pp.a = true
      }else{
        this.pp.a = false
      }
      
      if(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(pass)){
        this.pp.c = true
      }else{
        this.pp.c = false
      }
    }
  },
  methods:{
    SendCode(){
      if(this.has_referral && !this.data.ref_code){
        this.errorMessage = 'لطفا کد معرف را وارد کنید'
        return;
      }
      this.activeLoading(true)
      this.data.password = this.password
      this.$axios.post(`sendVerifyCode` , this.data)
      .then(res => {
        this.StoreNumber(this.data.mobile_number);
        this.$router.push({name:'VerifyCode'});
        this.activeLoading(false)
      })
      .catch(err => {
        if(err.response.data.message){
          this.errorMessage = err.response.data.message
          this.errors = {}
        }else if(err.response.data.errors){
          this.errors = err.response.data.errors
          this.errorMessage = null
        }
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkUnAuthenticated()
    
    const refCode = this.$route.query.rf;
    if(refCode){
      this.is_ref_code_disable = true;
      this.data.ref_code = refCode;
    }
  }
}
</script>
